import { render, staticRenderFns } from "./FindIdResult.vue?vue&type=template&id=50ed52b3&"
import script from "./FindIdResult.vue?vue&type=script&lang=ts&"
export * from "./FindIdResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports